var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, Box, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectors, } from "paul-core-package";
var EXPLANATION_KEYS = [
    "ENERGY_SAVING_VALUES_EXPLANATION",
    "ENERGY_SAVING_MEASUREMENT_EXPLANATION",
    "ENERGY_SAVING_CONSUMPTION_EXPLANATION",
];
export var CompareTwoValuesExplanation = function () {
    var tI = useSelector(selectors.getActiveTranslationsInterfaceUILocalizations);
    var theme = useTheme();
    return (_jsx(Box, __assign({ sx: {
            pb: 10,
            mb: 3,
            borderBottom: "1px solid ".concat(theme.palette.action.focus),
        } }, { children: EXPLANATION_KEYS.map(function (key) { return (_jsx(Box, __assign({ mb: 2 }, { children: _jsx(Typography, __assign({ variant: "body1", color: "textPrimary" }, { children: tI[key] })) }), key)); }) })));
};
